var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid container-home vertical-center"},[_c('div',{staticClass:"container"},[_c('da-welcome')],1)]),_vm._v(" "),_c('div',{staticClass:"container container-publications"},[_c('div',{staticClass:"row"},[_c('da-publications')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29dd100d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 432
// module chunks = 0